import defineReadAutoAction from '~/prix/actions/defineReadAutoAction'
import legalEntityUnnestCnaeAction from './legalEntityUnnestCnaeRead.action.json'

const legalEntityUnnestCnaeDefinition = defineReadAutoAction(
  legalEntityUnnestCnaeAction,
  'legalEntityUnnestCnae',
)

export default legalEntityUnnestCnaeDefinition
